export const locale = {
  lang: "it",
  data: {
    MENU: {
      PROVIDERS_COST: "Fornitori",
      STRUCUTURE_COST: "Struttura",
    },
    ALERT: {
      SUCCESS_CREATE_PROVIDER_COST: "Costo fornitore creato con successo.",
      ERROR_CREATE_PROVIDER_COST: "Errore nella creazione del costo fornitore.",
      SUCCESS_EDIT_PROVIDER_COST: "Costo fornitore modificato con successo.",
      ERROR_EDIT_PROVIDER_COST: "Errore nella modifica del costo fornitore.",
      SUCCESS_DELETE_PROVIDER_COST: "Costo fornitore eliminato con successo.",
      ERROR_DELETE_PROVIDER_COST: "Errore nell'eliminazione del costo fornitore.",
      PROVIDER_COST_NOT_FOUND: "Costo fornitore non trovato.",
      ERROR_MONTH_GREATHER_THAN_MOMENT_NOW: "Non puoi visualizzare un periodo maggiore a quello corrente.",
      ERROR_IMPORT_PROVIDER_COST_NOT_EDITABLE: "L'importo del costo non è editabile perché composto dal totale dei sottocosti. Modifica uno dei sottocosti per modificare l'importo.",
      SUCCESS_CREATE_STRUCTURE_COST: "Costo struttura creato con successo.",
      ERROR_CREATE_STRUCTURE_COST: "Errore nella creazione del costo struttura.",
      SUCCESS_EDIT_STRUCTURE_COST: "Costo struttura modificato con successo.",
      ERROR_EDIT_STRUCTURE_COST: "Errore nella modifica del costo struttura.",
      SUCCESS_DELETE_STRUCTURE_COST: "Costo struttura eliminato con successo.",
      ERROR_DELETE_STRUCTURE_COST: "Errore nell'eliminazione del costo struttura.",
      AMOUNT_NOT_EDITABLE: "L'importo non è modificabile",
      DESCRIPTION_NOT_EDITABLE: "La descrizione non è modificabile",
      SUCCESS_STRUCTURE_COST_UPDATE: "Costo di struttura ricalcolato correttamente.",
      ERROR_STRUCTURE_COST_UPDATE: "Errore nel ricalcolo del costo di struttura."
    },
    ADD_NEW_COST: "Aggiungi nuovo costo",
    EDIT_COST: "Modifica costo",
    ADD_NEW_BELOW_COST: "Aggiungi nuovo sottocosto",
    EDIT_BELOW_COST: "Modifica sottocosto",
    ESTIMATED_COST: "Costo presunto",
    NO_COLLABORATORS_FOUND_FOR_THIS_PROVIDER: "Nessun collaboratore trovato per questo fornitore.",
    RELOAD_STRUCTURE_COSTS: "Ricalcola i costi"
  },
};
